module.exports = __webpack_public_path__ + "static/media/fa-solid-900.dbc43435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/webfonts/fa-solid-900.svg
// module id = 884
// module chunks = 0